import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MetaData from "../layout/MetaData";
import Loader from "../layout/Loader/Loader";
import { Link } from "react-router-dom";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout } from "../../actions/userAction";
import { clearWishlist } from "../../reducers/wishlistReducer";
import { getWishlist } from "../../actions/wishlistAction";

const Profile = () => {
    const navigate = useNavigate();
    const { user, loading, isAuthenticated } = useSelector((state) => state.user);
    console.log("Is user is authenticated : ", isAuthenticated);
    console.log("user in Profile : ", user);
    const dispatch = useDispatch();

    function logoutUser() {
        dispatch(clearWishlist());
        dispatch(logout());
        toast.success("Logout Successfully");
        navigate("/login");
    }

    useEffect(() => {
        if (isAuthenticated === false) {
            navigate("/login");
        } else {
            dispatch(getWishlist());
        }
    }, [navigate, isAuthenticated]);
    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <Fragment>
                    <MetaData title={`${user?.user?.name}'s Profile`} />

                    <div className="profileWrapper">

                        <div className="profileCard">

                            <div className="profileLeft">

                                <h2>My Account</h2>

                                <img
                                    src={user?.user?.avatar?.url}
                                    alt={user?.user?.name}
                                />

                                <Link className="editProfileBtn" to="/me/update">
                                    Edit Profile
                                </Link>

                            </div>

                            <div className="profileRight">

                                <div className="profileInfo">
                                    <h4>Full Name</h4>
                                    <p>{user?.user?.name}</p>
                                </div>

                                <div className="profileInfo">
                                    <h4>Email</h4>
                                    <p>{user?.user?.email}</p>
                                </div>

                                <div className="profileInfo">
                                    <h4>Joined On</h4>
                                    <p>{String(user?.user?.createdAt).substring(0, 10)}</p>
                                </div>

                                <div className="profileActions">
                                    <Link to="/orders">My Orders</Link>
                                    <Link to="/wishlist">My Wishlist</Link>
                                    <Link to="/password/update">Change Password</Link>
                                    <button onClick={logoutUser}>Logout</button>
                                </div>

                            </div>

                        </div>

                    </div>

                </Fragment>
            )}
        </Fragment>
    );
};

export default Profile;
